import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, COMPLIANCE, REVIEW } from "const"
import { StateType } from "client/utils"
import {
    StoreType,

    DeleteCcLibrarySetModule,
    DeleteAllCcComplianceRevisions,
    DeleteAllCcReviewComplianceRevisions,

    setCcLibrarySetModuleData,
    setCcLibrarySetModuleShowConfirm,
    setCcLibrarySetReloadList,
} from "client/store"
import {
    Button,
    SpinnerIcon,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
} from "client/components"

const ConfirmDeleteModule = () => {
    const setModuleData = useSelector((state: StoreType) => state.ccLibrarySetModule.data)
    const showConfirm = useSelector((state: StoreType) => state.ccLibrarySetModule.showConfirmDelete)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [confirmState, setConfirmState] = useState<StateType>(IDLE)

    const closeConfirm = () => {
        dispatch(setCcLibrarySetModuleData(null))
        dispatch(setCcLibrarySetModuleShowConfirm(false))
    }

    const onConfirm = () => {
        setConfirmState(PENDING)
        DeleteCcLibrarySetModule(setModuleData).then((removedRows) => {
            if (!removedRows) {
                setConfirmState(IDLE)
                dispatch(setCcLibrarySetModuleData(null))
                dispatch(setCcLibrarySetModuleShowConfirm(false))
                return
            }

            const promiseArray: Promise<any>[] = []

            if (setModuleData.module === COMPLIANCE) {
                promiseArray.push(
                    DeleteAllCcComplianceRevisions(setModuleData.setId),
                )
            }

            if (setModuleData.module === REVIEW) {
                promiseArray.push(
                    DeleteAllCcReviewComplianceRevisions(setModuleData.setId),
                )
            }

            Promise.all(promiseArray).then(() => {
                setConfirmState(IDLE)
                dispatch(setCcLibrarySetModuleData(null))
                dispatch(setCcLibrarySetModuleShowConfirm(false))

                dispatch(setCcLibrarySetReloadList(false))
                setTimeout(() => {
                    dispatch(setCcLibrarySetReloadList(true))
                }, 0)
            })
        })
    }

    return (
        <ConfirmWrapper
            show={showConfirm}
            onClose={closeConfirm}
        >
            <Confirm>
                <ConfirmTitle>{lang.delete}</ConfirmTitle>
                <ConfirmDescription>
                    {setModuleData && setModuleData.module === COMPLIANCE && lang.confirmDeleteSetFromCompliance}
                    {setModuleData && setModuleData.module === REVIEW && lang.confirmDeleteSetFromReview}
                </ConfirmDescription>

                <ConfirmBottom>
                    <Button row onClick={closeConfirm}>{lang.cancel}</Button>
                    <Button variant="success" row onClick={onConfirm}>
                        {confirmState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDeleteModule
